<template>
	<div v-if="products?.length" class="flex flex-wrap relative flex-1">
		<div
			v-if="title"
			class="text-center w-full mb-8 product-recommendations-title"
		>
			<component
				:is="titleTag"
				:class="titleStyles || (titleTag === 'span' ? 'text-3xl' : '')"
			>
				{{ title }}
			</component>
		</div>
		<!-- `aligning`: the base track centres slides, which breaks the card's
		`mt-auto`. A template fork that does not declare the prop keeps its own
		alignment — gotaplatsensfoto's already stretches. -->
		<Carousel
			v-if="isCarousel"
			:slides="products"
			:blok="{
				number_of_slides_to_show: '4',
				show_arrows: showArrows ?? true
			}"
			:type-of-slide="ItemType.PRODUCT"
			:show-add-to-cart="showAddToCart"
			:aligning="showAddToCart ? 'items-stretch' : undefined"
			class="w-full"
			@product-click="$emit('product-click', $event)"
		/>
		<div v-else :class="gridClass">
			<ProductCard
				v-for="product in products"
				:key="product.PartNo"
				:product="product"
				:show-add-to-cart="showAddToCart"
				:picture-size="pictureSize"
				picture-aspect-ratio="4/5"
				class="flex flex-col"
				@product-click="$emit('product-click', product)"
			/>
		</div>
	</div>
</template>

<script setup lang="ts">
import type { ProductItem } from "@nwt/norce-pwa/dist/runtime/types/api/product/product";
import { ItemType } from "~/utils/constants";
import type { RecommendationsTitleTag } from "~/layers/base/composables/useProductRecommendationsConfig";

// Presentation only — no fetching, no stores. Data half:
// `useProductRecommendations()`.
interface Props {
	products: ProductItem[];
	title?: string;
	titleStyles?: string;
	titleTag?: RecommendationsTitleTag;
	isCarousel?: boolean;
	showArrows?: boolean;
	/** Undefined = the card decides; the default below stops Vue's Boolean
	 * cast to `false`. */
	showAddToCart?: boolean;
	/** Narrow surfaces (the mini cart) override the four-across default. */
	gridClass?: string;
	pictureSize?: string;
}

withDefaults(defineProps<Props>(), {
	showAddToCart: undefined,
	titleTag: "span",
	gridClass: "grid grid-cols-2 lg:grid-cols-4 gap-8 w-full",
	pictureSize: "w-full h-auto"
});

defineEmits<{ "product-click": [product: Partial<ProductItem>] }>();
</script>
